import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SettingsSideNav from 'kingpin/navigation/SettingsSideNav';

import AppSideBar from './ProductSideBar';
import WorkspaceSideBar from './WorkspaceSideBar';
import MappedViewSidebar from './MappedViewSidebar';

const SideBar = () => {
  return (
    <Routes>
      <Route path="/apps/:productSlug/*" element={<AppSideBar />} />
      <Route
        path="/workspaces/:workspaceSlug/:itemKey/*"
        element={<WorkspaceSideBar />}
      />
      <Route
        path={'/views/:appSlug/:mappedEntityNavItemKey/*'}
        element={<MappedViewSidebar />}
      />
      <Route path={'/settings/*'} element={<SettingsSideNav />} />
    </Routes>
  );
};

export default SideBar;
